var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTileMoreSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.38,
    height: 314.045,
    viewBox: "0 0 68.38 314.045",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c5e0a9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(888.38 1157.045) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersection_2",
    "data-name": "Intersection 2",
    className: "cls-1",
    d: "M-1850,249.693c7.446,18.276,18.573,36.929,34.27,55.711L-1850,334.045ZM-1850,30a10,10,0,0,1,10-10h58.38c-17.591,17.389-50.455,54.216-68.38,101.837Z",
    transform: "translate(2670 823)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileMoreSoon);
export default __webpack_public_path__ + "static/media/tile-more-soon.9c6abdd2817dc2e5545bc550203ac54b.svg";
export { ForwardRef as ReactComponent };